import cn from 'classnames';
import Carousel from '@packages/shared/core/common/components/common/Carousel';
import ArrowButton, { ArrowButtonProps } from '@packages/shared/core/common/components/common/ArrowButton';
import { SECOND_IN_MS } from '@packages/shared/core/common/constants';
import Chip from '@packages/shared/core/common/components/common/Chip';
import styles from './ChatFooterIceBreakingTipsDesktop.module.scss';

type ChatFooterIceBreakingTipsDesktopProps = {
  className?: string;
  onSelectTip: (tip: string) => void;
  tips: Array<string>;
  selectedTip?: string;
};

const ChatFooterIceBreakingTipsDesktop = ({
  className,
  onSelectTip,
  tips,
  selectedTip,
}: ChatFooterIceBreakingTipsDesktopProps) => {
  const settings = {
    centerMode: false,
    infinite: true,
    arrows: true,
    variableWidth: true,
    swipe: false,
    speed: SECOND_IN_MS / 5,
    prevArrow: <IceBreakingTipsCarouselPrev />,
    nextArrow: <IceBreakingTipsCarouselNext />,
  };

  return (
    <div className={cn(styles.root, className)}>
      <Carousel {...settings}>
        {tips.map((tip, index) => (
          <div className={styles.slide} key={index}>
            <Chip
              className={styles.tip}
              labelProps={{ className: styles.tipLabel }}
              variant={tip === selectedTip ? 'primary' : 'primary-outlined'}
              onClick={() => onSelectTip(tip)}
            >
              {tip}
            </Chip>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

type IceBreakingTipsCarouselPrevProps = ArrowButtonProps;

const IceBreakingTipsCarouselPrev = ({ className, ...otherProps }: IceBreakingTipsCarouselPrevProps) => {
  return <ArrowButton {...otherProps} className={cn(styles.carouselPrev, className)} />;
};

type IceBreakingTipsCarouselNextProps = ArrowButtonProps;

const IceBreakingTipsCarouselNext = ({ className, ...otherProps }: IceBreakingTipsCarouselNextProps) => {
  return <ArrowButton {...otherProps} className={cn(styles.carouselNext, className)} />;
};

export default ChatFooterIceBreakingTipsDesktop;
